import { ADD_PIXEL, UPDATE_PIXEL, DESTROY_PIXEL, PIXEL_ROLLED, CHANGE_PIXEL_CHARACTER } from '../constants/action-types'

export function addPixel(pixelConfig) {
  return {
    type: ADD_PIXEL,
    payload: pixelConfig,
  }
}

export function updatePixel(pixelConfig) {
  return {
    type: UPDATE_PIXEL,
    payload: pixelConfig,
  }
}

export function destroyPixel(pixelId) {
  return {
    type: DESTROY_PIXEL,
    payload: { pixelId },
  }
}

export function pixelRolled(pixelId, lastRoll) {
  return {
    type: PIXEL_ROLLED,
    payload: { pixelId, lastRoll },
  }
}

export function changePixelCharacter(pixelId, characterId) {
  return {
    type: CHANGE_PIXEL_CHARACTER,
    payload: { pixelId, characterId },
  }
}

export const SET_PIXEL_CONNECTION_STATUS = 'SET_PIXEL_CONNECTION_STATUS';

export function setPixelConnectionStatus(pixelId, status) {
  return {
    type: SET_PIXEL_CONNECTION_STATUS,
    payload: { pixelId, status },
  };
}